import CurrentPageClientProvider from './CurrentPageClientProvider';

export default CurrentPageClientProvider;
